export default {
  '确认登出吗？': '确认登出吗？',
  '多语言': '多语言',
  '多语言配置，当页面需要支持多语言切换时，可使用此组件类配置静态多语言数据': '多语言配置，当页面需要支持多语言切换时，可使用此组件类配置静态多语言数据',
  '多语言配置': '多语言配置',
  '内容区': '内容区',
  '子组件文案': '子组件文案',
  '清空语言设置': '清空语言设置',
  '遍历收集': '遍历收集',
  '中英文': '中英文',
  '中文': '中文',
  '选择': '选择',
  '接口选择': '接口选择',
  '接口名称': '接口名称',
  '模块': '模块',
  'HTTP方法': 'HTTP方法',
  '接口类型': '接口类型',
  '操作': '操作',
  '接口查询': '接口查询',
  '数据库': '数据库',
  '查询': '查询',
  '上下结构': '上下结构',
  '上左右结构': '上左右结构',
  '深色': '深色',
  '浅色': '浅色',
  '待发布': '待发布',
  '已发布': '已发布',
  '已取消': '已取消',
  '默认': '默认',
  '从外链加载': '从外链加载',
  '从文件加载': '从文件加载',
  '菜单': '菜单',
  '按钮': '按钮',
  '是': '是',
  '否': '否',
  '登录认证': '登录认证',
  '无验证': '无验证',
  '工作台': '工作台',
  '应用编辑器': '应用编辑器',
  '新增目录': '新增目录',
  '确认删除吗？': '确认删除吗？',
  '编辑': '编辑',
  '设计': '设计',
  '页面说明': '页面说明',
  '删除': '删除',
  '新增子目录': '新增子目录',
  '新增子页面': '新增子页面',
  '应用名称': '应用名称',
  '新增': '新增',
  '主页': '主页',
  '数据源': '数据源',
  '接口管理': '接口管理',
  '共n条数据': '共{0}条数据',
  '应用描述': '应用描述',
  '应用ID': '应用ID',
  '应用密钥': '应用密钥',
  '主题': '主题',
  '状态': '状态',
  '获取数据失败': '获取数据失败',
  '编辑器': '编辑器',
  '电脑': '电脑',
  '手机': '手机',
  '预览': '预览',
  '保存': '保存',
  '发布': '发布',
  '确认发布吗？': '确认发布吗？',
  '发布成功': '发布成功',
  '发布失败': '发布失败',
  '保存成功': '保存成功',
  '保存失败': '保存失败',
  '取消': '取消',
  '基础信息': '基础信息',
  '功能': '功能',
  '权限字符': '权限字符',
  '数据范围': '数据范围',
  '类型': '类型',
  '主机': '主机',
  '端口': '端口',
  '服务名': '服务名',
  '相关表信息': '相关表信息',
  '添加表': '添加表',
  '参数名可不设置，若进行设置，则设置参数名后，对应表的查询条件应该在键为该参数名的json对象中；该表的返回数据也会在键为该参数名的json对象中。': '参数名可不设置，若进行设置，则设置参数名后，对应表的查询条件应该在键为该参数名的json对象中；该表的返回数据也会在键为该参数名的json对象中。',
  '参数名': '参数名',
  '当同一个表添加多次时，可对这些表设置别名以进行区分': '当同一个表添加多次时，可对这些表设置别名以进行区分',
  '表别名': '表别名',
  '表关联关系': '表关联关系',
  '添加关联字段': '添加关联字段',
  '相等': '相等',
  '查询参数信息': '查询参数信息',
  '添加参数': '添加参数',
  '排序信息': '排序信息',
  '升序': '升序',
  '降序': '降序',
  '返回字段信息': '返回字段信息',
  '更新字段信息': '更新字段信息',
  '插入字段信息': '插入字段信息',
  '本部门': '本部门',
  '本人': '本人',
  '字段名': '字段名',
  '对应表': '对应表',
  '对应表字段': '对应表字段',
  '字段描述': '字段描述',
  '条件': '条件',
  '表': '表',
  '字段': '字段',
  '字段类型': '字段类型',
  '表名': '表名',
  '被关联表名': '被关联表名',
  '被关联字段': '被关联字段',
  '关联方式': '关联方式',
  '请输入': '请输入',
  '请选择': '请选择',
  '与主表关系': '与主表关系',
  '备注': '备注',
  '主表': '主表',
  '从表': '从表',
  '请选择数据库': '请选择数据库',
  '请选择数据表': '请选择数据表',
  '请添加相关表信息': '请添加相关表信息',
  '请设置关联字段': '请设置关联字段',
  '字段名不可为空': '字段名不可为空',
  '接口地址': '接口地址',
  '地址': '地址',
  '测试环境': '测试环境',
  '预发布环境': '预发布环境',
  '生产环境': '生产环境',
  '删除失败': '删除失败',
  '获取数据失败': '获取数据失败',
  '数据库配置': '数据库配置',
  '测试连接': '测试连接',
  '数据库类型': '数据库类型',
  '用户名': '用户名',
  '密码': '密码',
  '选择字段': '选择字段',
  '选择数据表': '选择数据表',
  '可否为空': '可否为空',
  '可空': '可空',
  '非空': '非空',
  '默认值': '默认值',
  '编辑应用': '编辑应用',
  '新增应用': '新增应用',
  '应用图标': '应用图标',
  '选择图标': '选择图标',
  '应用布局': '应用布局',
  '父目录': '父目录',
  '目录名称': '目录名称',
  '排序': '排序',
  '无': '无',
  '目录': '目录',
  '页面名称': '页面名称',
  '英文名': '英文名',
  '页面加载方式': '页面加载方式',
  '外链地址': '外链地址',
  '页面文件': '页面文件',
  '页面信息': '页面信息',
  '确定': '确定',
  '页面目录': '页面目录',
  '页面地址': '页面地址',
  '二维码': '二维码',
  '下载': '下载',
  '部门名称': '部门名称',
  '部门编码': '部门编码',
  '应用': '应用',
  '成员': '成员',
  '字典名称': '字典名称',
  '字典编码': '字典编码',
  '内容': '内容',
  '标题': '标题',
  '业务类型': '业务类型',
  '请求方法': '请求方法',
  '操作人': '操作人',
  '请求时间': '请求时间',
  '响应时间': '响应时间',
  '返回状态': '返回状态',
  '菜单名称': '菜单名称',
  '菜单类型': '菜单类型',
  '菜单标识': '菜单标识',
  '组件': '组件',
  '访问地址': '访问地址',
  '权限字符': '权限字符',
  '验证类型': '验证类型',
  '顺序号': '顺序号',
  '角色名称': '角色名称',
  '角色标识': '角色标识',
  '权限': '权限',
  '用户名称': '用户名称',
  '设置密码': '设置密码',
  '设置角色': '设置角色',
  '登录账号': '登录账号',
  '角色': '角色',
  '正常': '正常',
  '禁用': '禁用',
  '添加部门': '添加部门',
  '编辑部门': '编辑部门',
  '所属应用': '所属应用',
  '上级部门': '上级部门',
  '添加用户': '添加用户',
  '账号状态': '账号状态',
  '账户名': '账户名',
  '请选择要添加的用户': '请选择要添加的用户',
  '添加用户成功': '添加用户成功',
  '添加用户失败': '添加用户失败',
  '部门成员': '部门成员',
  '编辑字典内容信息': '编辑字典内容信息',
  '新增字典内容信息': '新增字典内容信息',
  '所属字典': '所属字典',
  '英文标题': '英文标题',
  '值': '值',
  '字典内容': '字典内容',
  '内容英文': '内容英文',
  '编辑字典信息': '编辑字典信息',
  '新增字典信息': '新增字典信息',
  '日志信息': '日志信息',
  '链接地址': '链接地址',
  '请求IP': '请求IP',
  '操作系统': '操作系统',
  '浏览器': '浏览器',
  '编辑菜单信息': '编辑菜单信息',
  '新增菜单信息': '新增菜单信息',
  '上级菜单': '上级菜单',
  '绑定页面': '绑定页面',
  '验证方式': '验证方式',
  '选择菜单': '选择菜单',
  '编辑角色信息': '编辑角色信息',
  '新增角色信息': '新增角色信息',
  '角色名称': '角色名称',
  '角色标识': '角色标识',
  '编辑用户信息': '编辑用户信息',
  '新增用户信息': '新增用户信息',
  '姓名': '姓名',
  '登录名': '登录名',
  '确认密码': '确认密码',
  '密码不一致': '密码不一致',
  '登录失败': '登录失败',
  '账号登录': '账号登录',
  '请输入账户名': '请输入账户名',
  '请输入密码': '请输入密码',
  '登录': '登录',
  '左右结构': '左右结构',
  '密钥信息': '密钥信息',
  '基础信息': '基础信息',
  '布局信息': '布局信息',
  '是否模板': '是否模板',
  '复制': '复制',
  '确认复制应用吗？': '确认复制应用吗？',
  '操作成功': '操作成功',
  '操作失败': '操作失败',
  '消息模板配置': '消息模板配置',
  '消息模板': '消息模板',
  '触发类型': '触发类型',
  '触发接口地址': '触发接口地址',
  '模板内容': '模板内容',
  '新增': '新增',
  '更新': '更新',
  '序号': '序号',
  '消息内容': '消息内容',
  '创建时间': '创建时间',
  '导入': '导入',
  '上传': '上传',
  '下载模板': '下载模板',
  '点击此处上传': '点击此处上传',
  '导入字典': '导入字典',
  '请按照模板要求，导入字典信息。': '请按照模板要求，导入字典信息。',
  '认证接口': '认证接口',
  '用户信息接口': '用户信息接口',
  '自定义': '自定义',
  '系统权限': '系统权限',
  '系统菜单': '系统菜单',
  '应用菜单': '应用菜单',
  '是否发布': '是否发布',
  '本部统一身份认证': '本部统一身份认证',
  '校区统一身份认证': '校区统一身份认证',
  '哈工大APP扫码登录': '哈工大APP扫码登录',
  '用户咨询': '用户咨询',
  '统一身份认证登录失败': '统一身份认证登录失败',
  '返回': '返回',
}